import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import './Helpertext.scss'
import withTheme from '../styles/withTheme'

const HelperText = forwardRef(function HelperText(props, ref) {
	const { children, className, component: Component = 'span', isError = false, ...other } = props

	return (
		<Component className={clsx('Vb-helpertext', isError && 'Vb-helpertext--error', className)} ref={ref} {...other}>
			{children === ' ' ? (
				// eslint-disable-next-line react/no-danger
				<span dangerouslySetInnerHTML={{ __html: '&#8203;' }} />
			) : (
				children
			)}
		</Component>
	)
})

export default withTheme('Vb-helpertext')(HelperText)

HelperText.propTypes = {
	/**
	 * The content of the component.
	 *
	 * If `' '` is provided, the component reserves one line height for displaying a future message.
	 */
	children: PropTypes.node,
	/**
	 * The component used for the root node.
	 * Either a string to use a HTML element or a component.
	 */
	component: PropTypes.elementType,
	/**
	 * If `true`, helper text is be displayed in an error state.
	 */
	isError: PropTypes.bool
}
